import Typography from 'components/shared/Typography/Typography';

export const renderInfo = (title, description) => {
  return (
    <div className="flex flex-col gap-2">
      <Typography weight="medium" className="leading-[18px]">
        {title}
      </Typography>
      <Typography weight={400} size="small" color="neutral-700" className="leading-[22px]">
        {description}
      </Typography>
    </div>
  );
};
